import { fmtDate } from "../../lib/adminApi";

export const LeadsTable = ({ rows }) => (
  <table data-testid="admin-leads-table" className="w-full text-left text-sm">
    <thead>
      <tr className="border-b border-forest/10 text-xs font-bold uppercase tracking-[0.15em] text-forest/50">
        <th className="px-6 py-4">#</th>
        <th className="px-6 py-4">Email</th>
        <th className="px-6 py-4">Referrals</th>
        <th className="px-6 py-4">Source</th>
        <th className="px-6 py-4">Joined list</th>
      </tr>
    </thead>
    <tbody>
      {rows.length === 0 && (
        <tr>
          <td colSpan={5} className="px-6 py-10 text-center text-forest/40">
            Nothing here yet.
          </td>
        </tr>
      )}
      {rows.map((r, i) => (
        <tr key={r.id} className="border-b border-forest/5 font-semibold text-forest last:border-0">
          <td className="px-6 py-4 font-syne font-extrabold text-forest/70">#{i + 1}</td>
          <td className="px-6 py-4">{r.email}</td>
          <td className="px-6 py-4">
            <span className="rounded-full bg-fresh/10 px-3 py-1 text-xs font-bold text-fresh">
              {r.referrals || 0}
            </span>
          </td>
          <td className="px-6 py-4">
            <span
              data-testid={`lead-source-${r.id}`}
              className={`rounded-full px-3 py-1 text-xs font-bold ${
                r.utm_source ? "bg-forest/10 text-forest" : "bg-forest/5 text-forest/40"
              }`}
            >
              {r.utm_source || "direct"}
            </span>
          </td>
          <td className="px-6 py-4 text-forest/60">{fmtDate(r.created_at)}</td>
        </tr>
      ))}
    </tbody>
  </table>
);
